(ns logseq.common.cognito-config
  "Shared Cognito configuration for frontend and CLI-safe consumers.")

(def COGNITO-CLIENT-ID
  "69cs1lgme7p8kbgld8n5kseii6")

(def CLI-COGNITO-CLIENT-ID
  "69cs1lgme7p8kbgld8n5kseii6")

(def OAUTH-DOMAIN
  "logseq-prod.auth.us-east-1.amazoncognito.com")

(def OAUTH-SCOPE "email openid phone")
